module.exports = __webpack_public_path__ + "img/logo.7fd76218.png";